import { Layout, PageHeader, Select, Space, Table, Button } from "antd";
import React, { useState, useEffect } from "react";
import { CameraOutlined } from "@ant-design/icons";
import "./Delivery.scss";
import ViewDeliveryProof from "./ViewDeliveryProof";
import { useSelector } from "react-redux";
import DriverService from "../../services/DriverService";
import * as dayjs from "dayjs";

const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);

const { Content } = Layout;

const ManageOrders = () => {
  const [selectedTab, setSelectedTab] = useState("Pending");
  const [addModal, setAddModal] = useState(false);
  const [proofs, setProofs] = useState([]);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [completedOrders, setCompletedOrders] = useState([]);
  const [allDriver, setAllDriver] = useState([]);
  const adminRestaurant = useSelector((state) => state.admin);

  const handleChange = async (value, id) => {
    await DriverService.assignDriver(id, value);
  };

  const getDropdownColor = (options, driverID) => {
    return options?.filter((item) => item.value === driverID)?.length > 0
      ? true
      : false;
  };

  const columns = [
    {
      title: "Order ID",
      dataIndex: "order_num",
      key: "order_num",
      className: "theme-red",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (e, record) => <div>{record?.order_status}</div>,
    },
    {
      title: "Pickup Address",
      dataIndex: "pickupAddress",
      key: "pickupAddress",
      render: (e, record) => <div>{record?.restaurant?.address}</div>,
    },
    {
      title: "Delivery Address",
      dataIndex: "deliveryAddress",
      key: "deliveryAddress",
      render: (e, record) => (
        <div>{record?.customer_location?.address_field1}</div>
      ),
    },
    {
      title: "Delivery Driver",
      key: "driver",
      dataIndex: "driver",
      render: (_, record) => (
        <Select
          defaultValue={
            record?.delivery_employee_id
              ? record?.delivery_employee_id
              : "Not Assigned"
          }
          style={{
            width: 180,
            border: getDropdownColor(allDriver, record?.delivery_employee_id)
              ? "1px solid #037236"
              : "1px solid #C32340",
          }}
          onChange={(value) => handleChange(value, record?.id)}
          options={allDriver}
        />
      ),
    },
    {
      title: "Time Elapsed",
      key: "delivery_time_mins",
      dataIndex: "delivery_time_mins",
      render: (val) => (
        <div>{val ? `${val} Minutes` : '-'}</div>
      ),
    },
  ];

  const completedColumn = [
    {
      title: "Order ID",
      dataIndex: "order_num",
      key: "order_num",
      className: "theme-red",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (e, record) => <div>{record.order_status.current_status}</div>,
    },
    {
      title: "Pickup Address",
      dataIndex: "pickupAddress",
      key: "pickupAddress",
      render: (e, record) => <div>{record.restaurant.address}</div>,
    },
    {
      title: "Delivery Address",
      dataIndex: "deliveryAddress",
      key: "deliveryAddress",
      render: (e, record) => (
        <div>{record.customer_location.address_field1}</div>
      ),
    },
    {
      title: "Delivery Driver",
      dataIndex: "deliveryDriver",
      key: "deliveryDriver",
      render: (e, record) => <div>{record?.delivery_employee?.name || ""}</div>,
    },
    {
      title: "Delivery Time",
      dataIndex: "delivery_time_mins",
      key: "delivery_time_mins",
      render: (val) => (
        <div>{val ? `${val} Minutes` : '-'}</div>
      ),
    },
    {
      title: "",
      dataIndex: "",
      key: "",
      render: (_, record) => {
        const photos = record.notes
          ?.map((item) => item.photo_url)
          .filter((n) => n);
        return (
          <>
            {Array.isArray(photos) && photos.length > 0 ? (
              <CameraOutlined
                className="cam-icon"
                onClick={() => setProofView(photos)}
              />
            ) : null}
          </>
        );
      },
    },
  ];

  const setProofView = (photos) => {
    setProofs(photos);
    setAddModal(true);
  };

  useEffect(() => {
    if (adminRestaurant) {
      // setSelectedRestaurant(adminRestaurant)
      getCompleted(adminRestaurant);
      getPending(adminRestaurant);
      getDriver(adminRestaurant);
    }
  }, [adminRestaurant]);

  const getCompleted = async (id) => {
    const data = await DriverService.getOrders(id);
    setCompletedOrders(data?.orders || []);
  };

  const getPending = async (id) => {
    const data = await DriverService.getUnassignedOrder(id);
    setPendingOrders(data?.orders || []);
  };

  const getDriver = async (id) => {
    const data = await DriverService.getAllDrivers(id);
    const driverArr = data?.drivers.map((item) => {
      const obj = {
        value: item.id,
        label: item.name,
      };
      return obj;
    });
    setAllDriver(driverArr);
  };
  return (
    <Layout className="u-page-layout">
     <Content>
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader
            title="Manage Orders"
            className="page-header"
            extra={[
              <div className="button-div">
              <Button
                className={
                  selectedTab === "Pending"
                    ? "selected-tab-button custom-btn"
                    : "button-grp-border default-button custom-btn"
                }
                type="primary"
                onClick={() => {
                  setSelectedTab("Pending");
                }}
              >
                Pending ({pendingOrders.length})
              </Button>
              <Button
                className={
                  selectedTab !== "Pending"
                    ? "selected-tab-button custom-btn"
                    : "button-grp-border default-button custom-btn"
                }
                type="primary"
                onClick={() => {
                  setSelectedTab("Completed");
                }}
              >
                Completed
              </Button>
            </div>,
            ]}
          />
          <div className="text-left">
            <Table
            className="overflow-auto"
              columns={selectedTab === "Pending" ? columns : completedColumn}
              dataSource={
                selectedTab === "Pending" ? pendingOrders : completedOrders
              }
            />
          </div>
        </Space>
      </Content>
      {addModal && (
        <ViewDeliveryProof
          modalOpen={true}
          closeModal={setAddModal}
          proofs={proofs}
        />
      )}
    </Layout>
  );
};

export default ManageOrders;
